export default "__VITE_ASSET__7c72a330__"